import { useState, useCallback } from "react"
import { useVenue } from "providers/venue"
import { RouteContext } from "./RouteContext"

export const RouteProvider = ({ children }) => {
  const [route, setRoute] = useState(null)
  const { findRoute, normalizeStepInRoute, findElevatorPreferredRoute } =
    useVenue()

  const calculateRoute = useCallback(
    async (origin, destination) => {
      const route = await findRoute(origin, destination)
      const normalizedRoute = normalizeStepInRoute(route)
      if (!normalizedRoute) return setRoute({ origin, destination })
      return setRoute(normalizedRoute)
    },
    [findRoute, normalizeStepInRoute]
  )

  const calculateElevatorPreferredRoute = useCallback(
    async (origin, destination) => {
      const route = await findElevatorPreferredRoute(origin, destination)
      const normalizedRoute = normalizeStepInRoute(route)
      if (!normalizedRoute) return setRoute({ origin, destination })
      return setRoute(normalizedRoute)
    },
    [findElevatorPreferredRoute, normalizeStepInRoute]
  )

  const clearRoute = useCallback(() => {
    setRoute(null)
  }, [])

  const value = {
    route,
    findRoute: calculateRoute,
    findElevatorPreferredRoute: calculateElevatorPreferredRoute,
    clearRoute,
  }
  return <RouteContext.Provider value={value}>{children}</RouteContext.Provider>
}
